import {
  addPortServiceDetailsAPI,
  deletePortServiceDetailsAPI,
  getPortServiceDetailsAPI,
  updatePortServiceDetailsAPI,
} from "./api";

export const addPortServiceDetails = (id, data) => {
  return new Promise((resolve, reject) => {
    addPortServiceDetailsAPI(id, data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updatePortServiceDetails = (data) => {
  return new Promise((resolve, reject) => {
    updatePortServiceDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getPortServiceDetails = (data) => {
  return new Promise((resolve, reject) => {
    getPortServiceDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deletePortServiceDetails = (data) => {
  return new Promise((resolve, reject) => {
    deletePortServiceDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};